export default "__VITE_ASSET__POJayzdJ__"